import { cva } from '@/styled-system/css';

export const upsellHeaderRecipe = cva({
  base: {
    '[data-c11n-component="Upsell.Root"]:has([data-c11n-component="Upsell.CloseButton"]) &': {
      paddingInlineEnd: 'Upsell.Header.gap.content-toClose',
    },

    '& > [data-c11n-component="Heading"]': {
      color: 'inherit',
      textStyle: 'body-bold',
    },
  },
  variants: {
    tone: {
      neutral: {
        color: 'Upsell.Header.neutral.text',
      },
      soft: {
        color: 'Upsell.Header.soft.text',
      },
      hero: {
        color: 'Upsell.Header.hero.text',
      },
      impact: {
        color: 'Upsell.Header.impact.text',
      },
    },
  },
});
